import { DialogAppSDK, PageAppSDK } from "@contentful/app-sdk";
import { pollJobUntilComplete } from "../../api/backendClient";
import { updateToast, showTemporaryToast } from "../../utils/persistentToast";

export const OpenReviewModal = (project: any, sdk: PageAppSDK) => {

  return sdk.dialogs
    .openCurrent({
      title: "Project Files",
      width: "large",
      minHeight: "80vh",
      position: "center",
      parameters: {
        type: "ProjectFilesReview",
        data: project,
      },
    })
    .then((data) => {
      window.location.reload();
    });
};

export const OpenUpdateModal = (data: any, sdk: DialogAppSDK) => {

  return sdk.dialogs
    .openCurrent({
      title: "Project Files",
      width: 800,
      minHeight: "80vh",
      position: "center",
      allowHeightOverflow: false,
      parameters: {
        type: "TranslationReview",
        data: data,
      },
    })
    .then((resp) => {
      if(!resp) return;
      return resp;
    });
};

export const OpenTranslationStatusReportModal = (sdk: PageAppSDK) => {
  return sdk.dialogs
    .openCurrent({
      title: "Translation Status Report",
      width: "fullWidth",
      minHeight: "80vh",
      allowHeightOverflow: false,
      parameters: {
        type: "translationStatusReport",
      },
    });
};

export const OpenNewRequestModal = (sdk: PageAppSDK) => {
  return sdk.dialogs
    .openCurrent({
      title: "New Request for Quote",
      width: 800,
      minHeight: "80vh",
      allowHeightOverflow: false,
      parameters: {
        type: "newRequest",
      },
    })
    .then((data: { jobId?: string; success?: boolean } | undefined) => {
      // If dialog was closed without submitting, do nothing
      if (!data || !data.success || !data.jobId) {
        return;
      }

      const jobId = data.jobId;
      const startTime = Date.now();
      const FIVE_MINUTES = 5 * 60 * 1000;
      let hasShownLongRunningMessage = false;

      // Show persistent toast - same element is reused and only text changes
      updateToast("Request submitted successfully. Processing in background...", "success");

      // Poll for job completion
      pollJobUntilComplete(jobId, (job) => {
        const elapsedTime = Date.now() - startTime;

        // Check if job is taking more than 5 minutes
        if (elapsedTime > FIVE_MINUTES && !hasShownLongRunningMessage) {
          hasShownLongRunningMessage = true;
          updateToast("Process is taking longer than expected. You can check the status later.", "warning");
          return;
        }

        // Update toast text with progress (don't update if already showing long-running message)
        if (job.status === 'processing' && !hasShownLongRunningMessage) {
          updateToast(`Processing translation... ${job.progress || 0}%`, "info");
        }
      }).then((completedJob) => {
        // Job completed successfully
        const resultCount = completedJob.result?.translatedCount || completedJob.result?.submittedCount || 0;
        const failedCount = completedJob.failedItems?.length || 0;

        if (failedCount > 0) {
          showTemporaryToast(`Translation completed with ${failedCount} failed item(s). ${resultCount} item(s) processed successfully.`, "warning", 5000);
        } else {
          showTemporaryToast(`Translation completed successfully. ${resultCount} item(s) processed.`, "success", 3000);
        }

        // Reload to refresh the quotes/projects list
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }).catch((error) => {
        // Job failed
        showTemporaryToast("Translation failed: " + error.message, "error", 5000);
      });
    });
};
